import "./App.css";
import Router from "./router/router";
import { Provider, useSelector } from "react-redux";
import { store } from "./store";
import ToastNotification from "./components/ToastNotification";
import { ChatContext } from "./context/chatContext";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "animate.css";
import WOW from "wow.js";
import Loader from "./assets/images/loader/loader.gif";

function App() {
  const [isSubmtted, setIsSubmtted] = useState(false);
  const [isLoggedin, setIsLoggedin] = useState(false);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.user);
  console.log("user", user);

  const isLoading = useSelector((state) => state.user.isLoading);

  useEffect(() => {
    const wow = new WOW();
    wow.init();

    const checkAuth = () => {
      const isAuth = user && Object.keys(user).length > 0;
      const token = localStorage.getItem("GuideproAI_user");
      const isTokenValid = !!token;
      setIsLoggedin(isAuth || isTokenValid);
      setLoading(false);
    };

    checkAuth();
  }, [user, loading]);

  // Add a loader while authentication is checking
  if (loading) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-180px)]">
        <img src={Loader} alt="Loader" className="w-20" />
      </div>
    );
  }

  return (
    <body className="dark">
      <ChatContext.Provider
        value={{ isSubmtted, setIsSubmtted, setIsLoggedin }}
      >
        <ToastNotification />
        <Router isLoggedin={isLoggedin} isLoading={isLoading} />
      </ChatContext.Provider>
    </body>
  );
}

export default App;
